import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import { formatViews } from '@/utils/newsUtils';

interface HotRankingProps {
  items: NewsArticle[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3.5 border-b border-background-200">
        <span className="w-7 h-7 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center">
          <i className="ri-fire-line"></i>
        </span>
        <h2 className="text-base font-bold font-heading text-foreground-950">热门榜单</h2>
        <span className="ml-auto text-xs text-foreground-400">按浏览量</span>
      </div>
      <ol className="p-2">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="flex items-start gap-3 rounded-md p-3 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-sm font-bold font-heading ${
                  i < 3 ? 'bg-primary-500 text-primary-50' : 'bg-background-200 text-foreground-500'
                }`}
              >
                {i + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  {formatViews(item.views)} 阅读
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}